import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import './App.css';
import './index.css';
import './styles/main.css';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';

function App() {
  useEffect(() => {
    document.body.classList.add('bg-[#F9FAFB]');
  });

  return (
    <main className='flex flex-col h-screen bg-[#F9FAFB]'>
      <div className='flex flex-1 overflow-hidden'>
        <Sidebar />
        <div className='flex flex-1 flex-col overflow-y-auto min-w-0 bg-[#F9FAFB]'>
          <Topbar />
          <Outlet />
        </div>
      </div>
    </main>
  );
}

export default App;
